<template>
  <Header12 />
  <div class="body">
    <section class="background-bleu">
      <MenuTitle title="Médiation" subTitle="" srcImg="/images/pages/gap/desc-picture.png"
        backgroundSpan="span-background-blue" />
    </section>
    <section>
      <NavLeft tab="mediation" breadcrumb1="" breadcrumb2="Médiation" />
    </section>
    <section class="background-bleu">
      <Expertises />
    </section>
    <section>
      <NousContacter />
    </section>
    <section>
      <Footer :dark_bg="true" />
    </section>
  </div>
</template>

<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue';
import Expertises from '@/components/emci/Homepage/Nos-expertises/index.vue';
import NousContacter from '@/components/emci/NousContacter/index.vue';
import Footer from '@/components/emci/Footer/index.vue'
import MenuTitle from "../MenuTitle";
import NavLeft from "@/components/emci/NavLeft/index.vue"
useHead({
    title: "EMCI - Qualité de vie au travail - la médiation",
    meta: [
        {
            name: "description",
            content: "Les espaces de médiation ou espaces de discussion permettent une discussion centrée sur l’expérience de travail, les règles de métiers, les ressources et les contraintes"
        }
    ]
})
</script>

<style scoped>
.body {
  
  overflow: hidden !important;
  margin-top: 120px;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
  .body {
    margin-top: 85px;
  }

  .background-bleu {
    margin-bottom: 50px;
  }
}
</style>